import { NameSplitColours } from "assets/icons"
import { Section, Image, Title, Details, WysiwygText } from "components/shared"

const Process = ({ id, description, image, process }) => {
  return (
    <Section
      id={id}
      className="bg-blue text-white antialiased overflow-visible"
      contentClassName="flex flex-col lg:flex-row  gap-16 lg:gap-32"
      padding="lg"
      animate
    >
      <Image image={image} className="flex-1 w-full min-h-[340px] md:min-h-[500px] lg:h-[800px]" animate />
      <div className="flex-1 space-y-8">
        <Title title="The Process" pretitle="procedure" size="sm" animate />
        {description && <WysiwygText text={description} animate />}
        <Details details={process} />
      </div>
      <div className="absolute bottom-[-382px] right-0 z-20">
        <NameSplitColours className="hidden lg:flex" />
      </div>
    </Section>
  )
}

export default Process
